import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAdminNotifications } from "src/components/organisms/NavMenu/RightSection/Notifications/CardList/SystemAdminCardList/utils";
import { getSystemAdminNotifications } from "./selectors";

export const useSystemAdminNotifications = () =>
  useSelector(getSystemAdminNotifications);

export const useSystemAdminNofificationsObject = () => {
  const notifications = useSystemAdminNotifications();

  const { notifTemplateNotification, defaultMappingNotification } = useMemo(
    () => getAdminNotifications(notifications),
    [notifications]
  );

  return { notifTemplateNotification, defaultMappingNotification };
};
